import { paymentTypes } from 'lib/constants/healthcareProgram/paymentSetup';

import Typography from 'components/shared/Typography/Typography';

import {
  toggleMethodChannelAction,
  updateMethodConfigAction
} from '../../../../lib/paymentSetupReducer';

import PaymentChannelList from './PaymentType/PaymentChannelList';
import TypeAccordion from './PaymentType/TypeAccordion';

const CHANNEL_KEYS = {
  'in-person': 'in_person',
  remote: 'remote'
};

const PaymentTypes = ({ methods = [], dispatch }) => {
  const handleToggle = (channel) => (field, enabled) => {
    dispatch(toggleMethodChannelAction(field, CHANNEL_KEYS[channel], enabled));
  };

  const handleUpdateConfig = (field, config) => {
    dispatch(updateMethodConfigAction(field, config));
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Typography variant="label" size="large" weight="medium">
          Payment types allowed
        </Typography>
        <Typography variant="p" size="small" color="neutral-700">
          Enable the payment methods your practice accepts. All are on by default — turn off any you
          don't want to offer. Options shown here drive what patients see on their Patient Option
          Letter.
        </Typography>
      </div>
      <div className="flex flex-col gap-4">
        {paymentTypes.map((option) => (
          <TypeAccordion key={option.value} title={option.title} icon={option.icon}>
            <PaymentChannelList
              channel={option.value}
              channelKey={CHANNEL_KEYS[option.value]}
              methods={methods}
              onToggle={handleToggle(option.value)}
              onUpdateConfig={handleUpdateConfig}
            />
          </TypeAccordion>
        ))}
      </div>
    </div>
  );
};

export default PaymentTypes;
